import { useEffect, useState } from "react";

export default function useIsMobile(breakpointPx = 768) {
  const getInitial = () => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= breakpointPx;
  };

  const [isMobile, setIsMobile] = useState<boolean>(getInitial);

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (typeof window.matchMedia === "function") {
      const mq = window.matchMedia(`(max-width: ${breakpointPx}px)`);
      const handler = () => setIsMobile(mq.matches);
      handler();

      if (mq.addEventListener) {
        mq.addEventListener("change", handler);
        return () => mq.removeEventListener?.("change", handler);
      } else {
        mq.addListener?.(handler);
        return () => {
          mq.removeListener?.(handler);
        };
      }
    }

    const onResize = () => setIsMobile(window.innerWidth <= breakpointPx);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpointPx]);

  return isMobile;
}
